"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Input = _interopRequireDefault(require("./Input"));

var _InputContainer = _interopRequireDefault(require("./InputContainer"));

var _Label = _interopRequireDefault(require("../Label"));

var _Typeahead = require("./Typeahead");

var _util = require("../../Util/util");

var _VisuallyHidden = _interopRequireDefault(require("../../VisuallyHidden"));

var CollegeInput = function CollegeInput(_ref) {
  var id = _ref.id,
      label = _ref.label,
      errorText = _ref.errorText,
      value = _ref.value,
      onChange = _ref.onChange,
      debounce = _ref.debounce,
      onSelect = _ref.onSelect,
      limit = _ref.limit,
      cancelable = _ref.cancelable,
      isHiddenLabel = _ref.isHiddenLabel,
      descriptiveTextId = _ref.descriptiveTextId,
      asterisks = _ref.asterisks,
      fsMask = _ref.fsMask,
      otherProps = (0, _objectWithoutProperties2.default)(_ref, ["id", "label", "errorText", "value", "onChange", "debounce", "onSelect", "limit", "cancelable", "isHiddenLabel", "descriptiveTextId", "asterisks", "fsMask"]);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      focused = _useState2[0],
      setFocused = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      selection = _useState4[0],
      setSelection = _useState4[1];

  var onFocus = function onFocus(e) {
    return setFocused(e.type === 'focus');
  };

  var selectOption = function selectOption(value) {
    setSelection(value.name);
    onSelect(value);
  };

  return /*#__PURE__*/_react.default.createElement(_Typeahead.TypeaheadContainer, {
    cancelable: cancelable,
    debounce: debounce,
    disabled: !focused || selection === value || !value || value.length < 2,
    id: id,
    onAutocompleteSelection: onSelect,
    onChange: onChange,
    onFocus: onFocus,
    selectOption: selectOption,
    setSelection: setSelection,
    value: value,
    url: "https://".concat(_util.isProd ? '' : 'test.', "figure.com/service-profile/external/api/v1/college/typeahead?maxResults=").concat(limit, "&partialName=")
  }, function (childrenProps) {
    var hideMenu = childrenProps.hideMenu,
        highlightedIndex = childrenProps.highlightedIndex,
        inputProps = childrenProps.inputProps,
        labelId = childrenProps.labelId,
        menuId = childrenProps.menuId,
        results = childrenProps.results,
        statusMessage = childrenProps.statusMessage;
    return /*#__PURE__*/_react.default.createElement(_InputContainer.default, {
      errorText: errorText
    }, /*#__PURE__*/_react.default.createElement(_Label.default, {
      htmlFor: id,
      errorText: errorText,
      id: labelId,
      isVisuallyHidden: isHiddenLabel,
      asterisks: asterisks
    }, label), /*#__PURE__*/_react.default.createElement(_Input.default, (0, _extends2.default)({
      fsMask: fsMask,
      errorText: errorText,
      "aria-invalid": errorText ? 'true' : null,
      "aria-describedby": descriptiveTextId
    }, otherProps, inputProps)), results.length > 0 && /*#__PURE__*/_react.default.createElement(_Typeahead.Typeahead, {
      fsMask: fsMask,
      results: results,
      id: menuId,
      handleSelect: function handleSelect(value) {
        selectOption(value);
        hideMenu();
      },
      highlightedIndex: highlightedIndex,
      labelledBy: labelId,
      renderRow: function renderRow(college) {
        return "".concat(college.name, " - ").concat(college.stateCode);
      }
    }), /*#__PURE__*/_react.default.createElement(_VisuallyHidden.default, {
      as: "div",
      "aria-live": "polite",
      role: "status"
    }, /*#__PURE__*/_react.default.createElement("p", null, statusMessage)));
  });
};

CollegeInput.propTypes = {
  /** The id of the input */
  id: _propTypes.default.string.isRequired,

  /** The Label used for the input */
  label: _propTypes.default.string.isRequired,

  /** Used to control the input */
  value: _propTypes.default.string,

  /** Used for validation */
  errorText: _propTypes.default.string,

  /** Used to update the value */
  onChange: _propTypes.default.func.isRequired,

  /** Callback function to run when a selection is made on the autocomplete */
  onSelect: _propTypes.default.func.isRequired,

  /** Length of the debounce for the autocomplete */
  debounce: _propTypes.default.number,

  /** Length of the number or results per query */
  limit: _propTypes.default.number,

  /** If typeahead rows are cancelable */
  cancelable: _propTypes.default.bool,

  /** Ideally, label text is always visible.
   * If necessary, this prop will hide label text from sighted users while still making it available to assistive technology.
   * It will not hide error text.
   */
  isHiddenLabel: _propTypes.default.bool,

  /**
   * Links input helper text or footnote text to the input for assistive technology users.
   * Accepts either the id or multiple space-separated ids of the text you want to link to.
   */
  descriptiveTextId: _propTypes.default.string,

  /** The number of asterisks to render in the label */
  asterisks: _propTypes.default.number,

  /** Toggles masking input within FullStory */
  fsMask: _propTypes.default.bool
};
CollegeInput.defaultProps = {
  value: '',
  errorText: '',
  debounce: 100,
  limit: 20,
  cancelable: false,
  isHiddenLabel: false,
  descriptiveTextId: null,
  asterisks: null,
  fsMask: true
};
var _default = CollegeInput;
exports.default = _default;